import React, { useLayoutEffect } from 'react';
import {
  Routes,
  Route,
  useLocation,

} from 'react-router-dom';




import MainNavigation from './shared/components/Navigation/MainNavigation';
import Intro from './pages/components/Intro/Intro';
import UnderConstruction from './pages/components/TmpApp/UnderConstruction';
import IntroPage from './pages/IntroPage';
import Faq from './pages/components/Faq/Faq';
import Imprint from './pages/Imprint';
import Dsgvo from './pages/Dsgvo';
import Downloads from './pages/Downloads';
import Divisions from './pages/Divisions';


import Footer from './shared/components/Footer/Footer';




import './App.css';


function App() {



  const routes = [
    { path: '/', name: 'Intro', element: <IntroPage /> },
    { path: '/sparten', name: 'News', element: <Divisions /> },
    { path: '/blog', name: 'Blog', element: <UnderConstruction /> },
    { path: '/documents', name: 'Dokumente', element: <Downloads /> },
    { path: '/faq', name: 'FAQ', element: <Faq /> },
    { path: '/impressum', name: 'Impressum', element: <Imprint /> },
    { path: '/disclaimer', name: 'Disclaimer', element: <Dsgvo /> },

  ]

  const routeComponents = routes.map(({ path, element }, key) =>
    <Route exact path={path} element={element} key={key} />
  );



  let location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);



  return (


    <React.Fragment>










      <MainNavigation />




      {/* <TransitionGroup>

          <CSSTransition
            key={location.pathname}
            classNames="fade"
            timeout={500}
            in={true}
            appear={true}
            unmountOnExit
          >
            <Routes>
              {routeComponents}
            </Routes>
          </CSSTransition>
        </TransitionGroup> */}


      <Routes>
        {routeComponents}
      </Routes>



      <Footer />




    </React.Fragment>












  );
}

export default App;
